<div class='container max--height'>
  <div class='row'>
    <div class='column--10 column-md--8 mx--auto align-center'>
      <img src="{{ CDN_URL }}/shared/images/not-found.svg" />
      <h3>Aw ship! Looks like we couldn't find what you're looking for...</h3>
    </div>
  </div>
</div>
